// Sistema antigo substituído pelo ModernMessageService
// Redirecionando para o novo sistema
import modernMessageService from './ModernMessageService';

// Exportar o novo sistema com a mesma interface
export default modernMessageService;
